// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1tM8d","savePackageButton":"ClientWallet_savePackageButton__27_L2"};